export function buildCurrentPageUrl(): string | null {
  const { origin, pathname, search, hash } = window.location;

  if (!URL.canParse(pathname, origin)) {
    return null;
  }

  const url = new URL(pathname, origin);
  url.search = search;
  url.hash = hash;
  return url.toString();
}
